import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
// import men from "../../assets/icons/men.png";
import { FaUser } from "react-icons/fa";
import Loader from "../../utils/Loader";
import { makeRequestAuth } from "../../_config/api";
import { showErrorToast } from "../../utils/toastUtils";
import formatDate from "../../utils/formateDate";

export default function Profile() {
  const [loading, setLoading] = useState(true);
  const [profile, setProfile] = useState(null);

  const fetchProfile = async () => {
    try {
      const res = await makeRequestAuth("post", "/admin/adminprofile");

      if (res?.error === false) {
        setProfile(res.data);
      } else {
        showErrorToast(res?.message || "Unable to load profile!");
      }
    } catch (error) {
      showErrorToast(error?.message || "Server error!");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProfile();
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center items-center py-20">
        <Loader />
      </div>
    );
  }

  if (!profile) return null;

  return (
    <div className="p-4 bg-white dark:bg-gray-900 mx-4 rounded-xl shadow-md border border-purple-300 dark:border-gray-700">
      <div className="flex items-center gap-6">
        {profile?.image ? (
  <img
    src={profile.image}
    alt="Profile"
    className="w-24 h-24 rounded-full object-cover border border-gray-300 dark:border-white/10"
  />
) : (
  <div className="w-24 h-24 rounded-full bg-gray-100 dark:bg-gray-800 flex items-center justify-center border border-gray-300 dark:border-white/10 text-gray-400">
    <FaUser size={40} />
  </div>
)}

        <div>
          <h2 className="capitalize text-2xl font-semibold text-gray-800 dark:text-white">
            {profile?.userName || "Admin"}
          </h2>

          <p className="text-gray-500 dark:text-gray-400 text-sm mt-1">
            Email: {profile?.email}
          </p>

          {profile?.location && (
            <p className="text-gray-500 dark:text-gray-400 text-sm mt-1">
              Location: {profile?.location}
            </p>
          )}
        </div>
      </div>

      <div className="border-b border-gray-300 dark:border-white/10 my-6"></div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        <div className="bg-gray-100 dark:bg-[#1E2430] p-3 rounded-xl border border-gray-300 dark:border-white/10">
          <span className="text-gray-700 dark:text-gray-300 font-semibold">
            Username:
          </span>
          <span className="capitalize text-gray-900 dark:text-white ml-1">
            {profile?.userName}
          </span>
        </div>

        <div className="bg-gray-100 dark:bg-[#1E2430] p-3 rounded-xl border border-gray-300 dark:border-white/10">
          <span className="text-gray-700 dark:text-gray-300 font-semibold">
            Mobile:
          </span>
          <span className="text-gray-900 dark:text-white ml-1">
            {profile?.phone}
          </span>
        </div>

        <div className="bg-gray-100 dark:bg-[#1E2430] p-3 rounded-xl border border-gray-300 dark:border-white/10">
          <span className="text-gray-700 dark:text-gray-300 font-semibold">
            Joined:
          </span>
          <span className="text-gray-900 dark:text-white ml-1">
            {formatDate(profile?.createdAt)}
          </span>
        </div>

        <div className="bg-gray-100 dark:bg-[#1E2430] p-3 rounded-xl border border-gray-300 dark:border-white/10">
          <span className="text-gray-700 dark:text-gray-300 font-semibold">
            Status:
          </span>
          <span className="px-2 py-1 rounded-full text-xs font-medium bg-emerald-100 text-emerald-700 dark:bg-emerald-700 dark:text-emerald-100 ml-1">
            {!profile?.isDisable ? "Active" : "Inactive"}
          </span>
        </div>
      </div>

      {/* Action Buttons */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Link to="/settings/profile/edit" state={profile}>
          <button className="w-full bg-[#6C35FF] hover:bg-[#5b2fd6] text-white py-3 rounded-xl font-medium transition">
            Edit Profile
          </button>
        </Link>

        <Link to="/settings/security">
          <button className="w-full bg-gray-100 dark:bg-[#1E2430] hover:bg-gray-200 dark:hover:bg-[#262d3f] text-gray-900 dark:text-white py-3 rounded-xl font-medium border border-gray-300 dark:border-white/10 transition">
            Account Settings
          </button>
        </Link>

        {/* <Link to="/">
          <button className="w-full bg-red-600 hover:bg-red-700 text-white py-3 rounded-xl font-medium transition">
            Delete Account
          </button>
        </Link> */}
      </div>
    </div>
  );
}
